__turbopack_context__.v({
  "arrow": "index-module-scss-module__p41PXq__arrow",
  "carousel": "index-module-scss-module__p41PXq__carousel",
  "dark": "index-module-scss-module__p41PXq__dark",
  "full": "index-module-scss-module__p41PXq__full",
  "indicator": "index-module-scss-module__p41PXq__indicator",
  "indicator-group": "index-module-scss-module__p41PXq__indicator-group",
  "inside": "index-module-scss-module__p41PXq__inside",
  "light": "index-module-scss-module__p41PXq__light",
  "marker": "index-module-scss-module__p41PXq__marker",
  "swiper": "index-module-scss-module__p41PXq__swiper",
});
